module.exports = __webpack_public_path__ + "img/image01.3801764a.jpg";